export { default } from './resolvers/classic';
